import React, { Component } from 'react';
import { Table } from 'antd';

import baseData from '@util/base';
import { queryFilePreview } from '@api/pub/attachment';

class TableFile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getType = type => {
    const index = baseData.attachmentType.findIndex(item => +item.key === +type);
    return index > -1 ? baseData.attachmentType[index].name : '';
  };

  handleDelete = uuid => {
    this.props.handleChooseFile(this.props.dataSource.filter(item => item.uuid !== uuid));
  };

  columns = () => {
    const { disabled, dataSource } = this.props;
    let columns = [
      {
        title: '文件类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return <span>{this.getType(text)}</span>;
        },
      },
      {
        title: '源文件',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => <a onClick={() => queryFilePreview(record)}>{text}</a>,
      },
      {
        title: '扫描件',
        dataIndex: 'scan',
        key: 'scan',
        render: (text, record) => {
          if (text) {
            return (
              <div key={text.url}>
                <a onClick={() => queryFilePreview(text)}> {text.name}</a>
              </div>
            );
          }
          return null;
        },
      },
    ];

    !dataSource.some(item => item.scan) &&
      (columns = columns.filter(item => item.title !== '扫描件'));

    return disabled
      ? columns
      : [
          ...columns,
          {
            title: '操作',
            dataIndex: 'done',
            render: (text, record) => {
              return disabled ? null : <a onClick={() => this.handleDelete(record.uuid)}>删除</a>;
            },
          },
        ];
  };

  render() {
    const { dataSource } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={dataSource}
        pagination={false}
        rowKey="uuid"
        onChange={this.handleTableChange}
      />
    );
  }
}

export default TableFile;



// WEBPACK FOOTER //
// ./src/components/incubator/comm/TableFile.js